const UNIT_TRANSLATIONS = {
  stk: {
    nl: "stk",
    en: "pcs",
    fr: "pcs",
  },
  kg: {
    nl: "kg",
    en: "kg",
    fr: "kg",
  },
  st: {
    nl: "stk",
    en: "pc",
    fr: "pc",
  },
  l: {
    nl: "l",
    en: "l",
    fr: "l",
  },
  mtr: {
    nl: "m",
    en: "m",
    fr: "m",
  },
  pak: {
    nl: "pak",
    en: "pak",
    fr: "paq",
  },
  par: {
    nl: "paar",
    en: "pair",
    fr: "pair",
  },
};

const getUnitTranslation = (unit, language) => {
  if (UNIT_TRANSLATIONS[unit]) {
    return UNIT_TRANSLATIONS[unit][language] || unit;
  }
  return unit;
};

module.exports = { UNIT_TRANSLATIONS, getUnitTranslation };
